import { track } from '@mc/track-event'

interface TrackPurchaseNowClick {
  pageSource: string
}

interface TrackModalClick {
  pageSource: string
  action: string
}

interface TrackModalViewed {
  pageSource: string
}

export const trackPurchaseNowClick = ({
  pageSource,
}: TrackPurchaseNowClick) => {
  track('Enterprise Purchase Now Clicked', {
    page_source: pageSource,
    location: 'self-service-purchase',
  })
}

export const trackModalClick = ({ pageSource, action }: TrackModalClick) => {
  track('Modal Clicked', {
    action,
    page_source: pageSource,
    modal_type: 'self_serve_purchase_now',
    product: 'MasterClass At Work',
  })
}

export const trackModalViewed = ({ pageSource }: TrackModalViewed) => {
  track('Modal Viewed', {
    page_source: pageSource,
    modal_type: 'self_serve_purchase_now',
    product: 'MasterClass At Work',
  })
}
